module.exports = __webpack_public_path__ + "img/boy_010034.aac09a54.png";